import { AppDispatchNext, AppGetState } from 'actions/actions.typesNext'
import { ChatEventReasons } from 'actions/messengerStopChat/constants'
import { createContactAction } from 'actions/metric/metricAction'
import { showPushNotificationsRequestModalIfNeededAction } from 'actions/push/showPushNotificationsRequestModalIfNeededAction'
import { Api6Error } from 'api/api.types'
import { apiResultHasErrors } from 'api/function/apiResultHasErrors'

import { showStopChatIfNeeded } from '../messengerStopChat/showStopChatIfNeeded'

export const afterSendMessageAction =
  (error: Api6Error) =>
  async (dispatch: AppDispatchNext, getState: AppGetState) => {
    const { metric } = getState()

    const hasErrors = apiResultHasErrors(error)

    if (hasErrors) {
      dispatch(showStopChatIfNeeded(ChatEventReasons.Send))
    }

    /**
     * Чтобы лишний раз не добавлять в лог,
     * сделаем проверку на что это новый пользователь.
     */
    if (!hasErrors && metric?.isNewUser && !metric?.isCreateContact) {
      dispatch(createContactAction())
    }

    if (!hasErrors) {
      dispatch(showPushNotificationsRequestModalIfNeededAction())
    }
  }
